import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import EnumFilteredDropdown from 'components/EnumFilteredDropdown';
import enumCollections from 'constants/enumCollections';
export var DEFAULT_TITLE = 'Language';
var LanguageDropdown = function (_a) {
    var _b;
    var defaultValue = _a.defaultValue, onSave = _a.onSave, _c = _a.dataTest, dataTest = _c === void 0 ? 'LanguageDropdown' : _c;
    var values = ((_b = enumCollections === null || enumCollections === void 0 ? void 0 : enumCollections.RIBBON_HEALTH_LANGUAGE_SEARCH_NAME) === null || _b === void 0 ? void 0 : _b.enumValues) || [];
    var items = values.map(function (i) { return ({
        label: i.description,
        value: i.name
    }); });
    return (_jsx(EnumFilteredDropdown, { isRadio: true, defaultValue: defaultValue, defaultTitle: DEFAULT_TITLE, items: items, onSave: onSave, dataTest: dataTest }));
};
export default LanguageDropdown;
